/* eslint-disable no-plusplus */
/* eslint-disable no-param-reassign */

import store from 'store2';
import { ValidityEvaluator, createEvaluateValidity } from '@bdelab/roar-utils';
// Import necessary for async in the top level of the experiment script
import 'regenerator-runtime/runtime';
// Local modules
import { jsPsych } from './jsPsych';
import { audio_feedback } from './trials/audio';
import {
  introduction_trials,
  introduction_trials_ns,
  post_practice_intro,
  if_coin_tracking,
} from './trials/introduction';
import { post_block_page_list, final_page } from './trials/gameBreak';
import { preloadTrials, isMaxTimeoutReached } from './helperFunctions';
import { setup_fixation } from './trials/setup';
import { multiAFC } from './trials/multiAFC';
import { exit_fullscreen } from './trials/fullscreen';
// CSS imports
import '../styles/game.scss';
import { initRoarJsPsych, initRoarTimeline } from './config/config';

// eslint-disable-next-line import/no-mutable-exports
export let vocabValidityEvaluator;

export function buildExperiment(config, firekit) {
  initRoarJsPsych(config);
  const initialTimeline = initRoarTimeline(firekit);

  const timeline = [preloadTrials, ...initialTimeline];

  // the core procedure
  const core_procedure = (numAFC) => ({
    timeline: [
      setup_fixation(numAFC, 'test_response'),
      multiAFC(numAFC, 'test_response'),
      audio_feedback,
      if_coin_tracking,
    ],
    conditional_function: () => !isMaxTimeoutReached(),
  });

  function pushPracticeToTimeline() {
    for (let i = 0; i < store.session.get('config').totalTrialsPractice; i++) {
      const block = {
        timeline: [
          setup_fixation(store.session.get('config').practiceTrialFormat[i], 'practice_response'),
          multiAFC(store.session.get('config').practiceTrialFormat[i], 'practice_response'),
          audio_feedback,
        ],
      };
      timeline.push(block);
    }
  }

  function pushTrialsToTimeline(stimulusCounts) {
    for (let i = 0; i < stimulusCounts.length; i++) {
      // for each block: add trials
      // add first half of block
      const roar_mainproc_block = {
        timeline: [core_procedure(store.session.get('config').orderAFC[i])],
        conditional_function: () => {
          if (stimulusCounts[i] === 0) {
            return false;
          }
          store.session.set('currentBlockIndex', i);
          return true;
        },
        repetitions: stimulusCounts[i],
      };

      timeline.push(roar_mainproc_block);

      if (i < stimulusCounts.length - 1) {
        const break_timeline = {
          timeline: post_block_page_list[i],
          conditional_function: () => !isMaxTimeoutReached(),
        };
        timeline.push(break_timeline);
      }
    }
  }

  if (store.session.get('config').story) {
    timeline.push(introduction_trials);
  } else {
    timeline.push(introduction_trials_ns);
  }
  pushPracticeToTimeline();
  timeline.push(post_practice_intro);
  pushTrialsToTimeline(store.session.get('config').stimulusCountList);
  timeline.push(final_page);
  timeline.push(exit_fullscreen);

  const vocabEvaluateValidity = createEvaluateValidity({
    responseTimeLowThreshold: 600,
    accuracyThreshold: 0.6,
    minResponsesRequired: 1,
    includedReliabilityFlags: ['incomplete'],
  });

  const vocabHandleEngagementFlags = (flags, reliable) => {
    if (config.firekit.run.started) {
      return config.firekit?.updateEngagementFlags(flags, reliable);
    }
    return null;
  };

  vocabValidityEvaluator = new ValidityEvaluator({
    evaluateValidity: vocabEvaluateValidity,
    handleEngagementFlags: vocabHandleEngagementFlags,
  });

  return { jsPsych, timeline };
}
